/**
 * GTM Initialization Script
 * Uses window.gtmConfig for configuration
 * @typedef {Object} GTMConfig
 * @property {boolean} enabled - GTM enabled status
 * @property {string} gtmId - GTM container ID
 * @property {boolean} bannerTracking - Banner tracking enabled
 * @property {boolean} addToCart - Add to cart tracking enabled
 * @property {boolean} purchaseEvent - Purchase event tracking enabled
 * @property {boolean} bidEvent - BID event tracking enabled
 */

// Check if GTM is enabled
// @ts-ignore - GTM config is injected by Liquid template
if (!window.gtmConfig || !window.gtmConfig.enabled) {
  console.log("GTM is disabled in theme settings");
} else {
  // Initialize dataLayer
  // @ts-ignore - dataLayer is GTM global variable
  window.dataLayer = window.dataLayer || [];

  /**
   * Persist Meta Click ID (_fbc) when landing with fbclid.
   * Improves fbc match rate for Purchase events sent via GTM / CAPI.
   */
  function captureMetaClickId() {
    try {
      const fbclid = new URL(window.location.href).searchParams.get("fbclid");
      if (!fbclid || document.cookie.includes("_fbc=")) return;

      const fbc = `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`;
      const maxAge = 90 * 24 * 60 * 60;
      document.cookie = `_fbc=${encodeURIComponent(fbc)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    } catch {
      /* ignore malformed URLs */
    }
  }

  captureMetaClickId();

  /**
   * SPA Page View Tracking (Horizon)
   * Tracks page type for SPA navigation
   */
  function firePageType() {
    const path = window.location.pathname;

    if (path === "/") {
      // @ts-ignore - dataLayer is GTM global variable
      dataLayer.push({ ecomm_pagetype: "home" });
      return;
    }

    if (path.includes("/collections/")) {
      // @ts-ignore - dataLayer is GTM global variable
      dataLayer.push({ ecomm_pagetype: "category" });
      return;
    }

    if (path.includes("/products/")) {
      // @ts-ignore - dataLayer is GTM global variable
      dataLayer.push({ ecomm_pagetype: "product" });
      return;
    }

    if (path.includes("/cart")) {
      // @ts-ignore - dataLayer is GTM global variable
      dataLayer.push({ ecomm_pagetype: "cart" });
    }
  }

  /**
   * Horizon SPA navigation listeners
   * Track page type changes during SPA navigation
   */
  document.addEventListener("shopify:section:load", firePageType);
  document.addEventListener("DOMContentLoaded", firePageType);
  window.addEventListener("popstate", firePageType);
}
